import { render, staticRenderFns } from "./ModalAtt.vue?vue&type=template&id=f608cf72&scoped=true&"
import script from "./ModalAtt.vue?vue&type=script&lang=js&"
export * from "./ModalAtt.vue?vue&type=script&lang=js&"
import style0 from "./ModalAtt.vue?vue&type=style&index=0&id=f608cf72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f608cf72",
  null
  
)

export default component.exports